import React, { useState, useEffect } from "react";
import { faqs as faqsFallback } from "./homeData/faqs";
import configService from "../../../services/configService";

export default function FAQ() {
  const [faqs, setFaqs] = useState(faqsFallback);
  const [open,        setOpen]      = React.useState(null);
  const [query,       setQuery]     = React.useState("");
  const [activeTag,   setTag]       = React.useState("All");
  const [focused,     setFocused]   = React.useState(false);
  const [visibleFaqs, setVisibleFaqs] = React.useState(4);
  const inputRef = React.useRef(null);

  useEffect(() => {
    configService.getConfig().then(r => {
      if (r.data?.faqs) setFaqs(r.data.faqs);
    }).catch(() => {});
  }, []);

  React.useEffect(() => { setVisibleFaqs(4); }, [query, activeTag]);

  const allTags = ["All", ...Array.from(new Set(faqs.map(f => f.tag)))];

  const filtered = faqs.filter(item => {
    const matchTag   = activeTag === "All" || item.tag === activeTag;
    const matchQuery = !query.trim() ||
      item.q.toLowerCase().includes(query.toLowerCase()) ||
      item.a.toLowerCase().includes(query.toLowerCase());
    return matchTag && matchQuery;
  });

  const toggle     = (i) => setOpen(open === i ? null : i);
  const clearSearch = () => { setQuery(""); inputRef.current?.focus(); };

const highlight = (text) => {
    if (!query.trim()) return text;
    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, i) =>
      regex.test(part) ? <mark key={i} className="home-faq__highlight">{part}</mark> : part
    );
  };

  return (
    <section className="home-faq">
      <div className="home-faq__bg" aria-hidden="true">
        <div className="home-faq__blob home-faq__blob--1" />
        <div className="home-faq__blob home-faq__blob--2" />
        <div className="home-faq__blob home-faq__blob--3" />
        <div className="home-faq__geo home-faq__geo--ring1" />
        <div className="home-faq__geo home-faq__geo--ring2" />
        <div className="home-faq__geo home-faq__geo--dot1" />
        <div className="home-faq__geo home-faq__geo--dot2" />
        <div className="home-faq__geo home-faq__geo--dot3" />
        <div className="home-faq__geo home-faq__geo--line1" />
        <div className="home-faq__geo home-faq__geo--line2" />
      </div>

      <div className="home-faq__inner">

        <div className="home-faq__head" data-aos="fade-left">
          <h2 className="home-faq__title">
            Frequently Asked
            <span className="home-faq__title-accent"> Questions</span>
          </h2>
          <p className="home-faq__sub">Everything you need to know — answered clearly and quickly.</p>
        </div>

        <div className="home-faq__search-wrap" data-aos="fade-right" data-aos-delay="80">
          <div className={`home-faq__search${focused ? " home-faq__search--focused" : ""}${query ? " home-faq__search--has-val" : ""}`}>

            <span className="home-faq__search-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </span>

            <input
              ref={inputRef}
              id="faq-search"
              name="faq-search"
              className="home-faq__search-input"
              type="text"
              placeholder="Search questions"
              value={query}
              onChange={e => { setQuery(e.target.value); setOpen(null); }}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              aria-label="Search FAQ"
            />

            {query && (
              <span className="home-faq__search-count">
                {filtered.length} result{filtered.length !== 1 ? "s" : ""}
              </span>
            )}

            {query && (
              <button className="home-faq__search-clear" onClick={clearSearch} aria-label="Clear search">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            )}

            <button className="home-faq__search-btn" aria-label="Search">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              
            </button>
          </div>

          {/* {!query && (
            <div className="home-faq__suggestions">
              <span className="home-faq__suggestions-label">Try:</span>
              {["processing time", "documents needed", "express visa", "refund policy"].map(s => (
                <button key={s} className="home-faq__suggestion-pill"
                  onClick={() => { setQuery(s); setOpen(null); }}>
                  {s}
                </button>
              ))}
            </div>
          )} */}
        </div>

        <div className="home-faq__tags" data-aos="fade-down" data-aos-delay="100">
          {allTags.map(tag => (
            <button
              key={tag}
              className={`home-faq__tag${activeTag === tag ? " home-faq__tag--active" : ""}`}
              onClick={() => { setTag(tag); setOpen(null); }}
            >
              {tag}
              {tag !== "All" && (
                <span className="home-faq__tag-count">
                  {faqs.filter(f => f.tag === tag).length}
                </span>
              )}
            </button>
          ))}
          {/* <span className="home-faq__tag-total">{filtered.length} of {faqs.length} shown</span> */}
        </div>

        <div className="home-faq__list" data-aos="fade-up">
          {filtered.length === 0 ? (
            <div className="home-faq__empty" data-aos="fade-up">
              <div className="home-faq__empty-icon">🔍</div>
              <h3 className="home-faq__empty-title">No results for "{query}"</h3>
              <p className="home-faq__empty-sub">Try a different keyword or clear the filter.</p>
              <button className="home-faq__empty-btn" onClick={clearSearch}>Clear search</button>
            </div>
          ) : (
            <>
              {filtered.slice(0, visibleFaqs).map((item, i) => {
                const globalIdx = faqs.indexOf(item);
                const isOpen    = open === globalIdx;
                return (
                  <div
                    key={globalIdx}
                    className={`home-faq__item${isOpen ? " home-faq__item--open" : ""}`}
                    data-aos={i % 2 === 0 ? "fade-right" : "fade-left"}
                    data-aos-delay={Math.min(i * 60, 240)}
                    style={{ animationDelay: `${i * 45}ms` }}
                  >
                    <button
                      className="home-faq__q"
                      onClick={() => toggle(globalIdx)}
                      aria-expanded={isOpen}
                    >
                      <span className="home-faq__q-num">{String(globalIdx + 1).padStart(2, "0")}</span>
                      <span className="home-faq__q-text">{highlight(item.q)}</span>
                      {/* <span className="home-faq__q-tag">{item.tag}</span> */}
                      <span className="home-faq__chevron">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" strokeWidth="2.3"
                          strokeLinecap="round" strokeLinejoin="round"
                          className={`home-faq__chevron-svg${isOpen ? " home-faq__chevron-svg--open" : ""}`}
                        >
                          <polyline points="6 9 12 15 18 9"/>
                        </svg>
                      </span>
                    </button>

                    <div className="home-faq__a-wrap">
                      <div className="home-faq__a-inner">
                        <div className="home-faq__a-bar" />
                        <p className="home-faq__a">{highlight(item.a)}</p>
                      </div>
                    </div>
                  </div>
                );
              })}

              {filtered.length > 4 && (
                <div className="home-view-more-wrap--faq">
                  <button
                    className="home-view-more-btn"
                    onClick={() => setVisibleFaqs(v => v < filtered.length ? Math.min(v + 3, filtered.length) : 3)}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points={visibleFaqs >= filtered.length ? "18 15 12 9 6 15" : "6 9 12 15 18 9"} />
                    </svg>
                    {visibleFaqs >= filtered.length
                      ? "Show Less"
                      : `View More FAQs (${filtered.length - visibleFaqs} remaining)`}
                  </button>
                </div>
              )}
            </>
          )}
        </div>

      </div>
    </section>
  );
}
